.menu {
    --menu-item-button-margin-inline: calc(-1 * var(--spacing-xs));
}

.popover {
    --base-popover-padding: var(--spacing-lg);
}
